export default __webpack_public_path__ + "static/media/marketing-image1.cb6be6cf.png";